/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ProductIdentityValue } from './ProductIdentityValue';
import type { RetailerDto } from './RetailerDto';

export type AggregatedProductIdentity = {
    type: AggregatedProductIdentity.type;
    values: Array<ProductIdentityValue>;
    hasAutoCalculatedThresholds: boolean;
    partialMatchThreshold?: number;
    fullMatchThreshold?: number;
    retailers: Array<RetailerDto>;
};

export namespace AggregatedProductIdentity {

    export enum type {
        SKU = 'SKU',
        NAME = 'NAME',
        AI = 'AI',
    }


}

